// Contest action types
export const FETCH_CONTESTS_REQUEST = 'FETCH_CONTESTS_REQUEST';
export const FETCH_CONTESTS_FAILURE = 'FETCH_CONTESTS_FAILURE';
export const FETCH_CONTESTS_SUCCESS = 'FETCH_CONTESTS_SUCCESS';
export const ADD_CONTEST_PLAYED = 'ADD_CONTEST_PLAYED';
export const UPDATE_CONTEST_CLOSE = `UPDATE_CONTEST_CLOSE`;
export const OMIT_CONTEST = 'OMIT_CONTEST';
export const UPDATE_CONTEST = 'UPDATE_CONTEST';
export const FETCH_CONTESTS_STATUS = 'FETCH_CONTESTS_STATUS';
export const TOGGLE_SELECT_COIN ='TOGGLE_SELECT_COIN';
export const TOGGLE_SELECT_DURATION='TOGGLE_SELECT_DURATION';
export const TOGGLE_VIEW = 'TOGGLE_VIEW';
export const SET_SELECTED_CONTEST = 'SET_SELECTED_CONTEST';
export const SET_SELECTED_COIN = 'SET_SELECTED_COIN';
export const SET_SELECTED_DURATION = 'SET_SELECTED_DURATION';
export const UPDATE_STATUS = 'UPDATE_STATUS';
